import clinic_1 from '../images/clinic_location_1.jpeg';
import techFaceMass from '../images/tech-face-massage.webp';
import techBackMass from '../images/tech-back-massage.webp';




export const BIMAGES = [
    {
        id: 'D65E3407-2DB5-4C47-B860-8CE8D7224A7D',
        image: techBackMass,
    },
    {
        id: 'DD0EC544-D981-4B85-91E4-FBEE430D7E49',
        image: techFaceMass,
    },
    { id: 'B59906C5-0774-437E-974E-6DCBCF8C1A8C', image: clinic_1 },
    // 6f7bc323-a9b2-404d-b8c8-ce1be1e33087
    { id: 'first-loc-img2', image: clinic_1 },
    { id: 'second-loc-img1', image: clinic_1 },
    { id: 'second-loc-img2', image: clinic_1 }
]

// export const BSERVICES = [
//     {
//         id: 1,
//         title: 'Массаж спины и ног',
//         serviceTemplateId: 'xy',
//         description: 'Технологичный массаж выверенными движенями рук наших прекрасных специалистов. ' +
//             'Правильность каждого движения контроллируется алгоритмом.' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл' +
//             'текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл, текст для того, чтобы проверить скролл',
//         description_2: 'Продолжительность: 60 минут',
//         imageList: [techBackMass],
//         category: 'massage',
//         chips:[],
//         price: '3990 рублей',
//     },
//     {
//         id: 2,
//         title: 'Массаж лица',
//         serviceTemplateId: 'xz',
//         description: '' +
//             '',
//         description_2: 'Продолжительность: 40 минут',
//         category: 'massage',
//         imageList: [techFaceMass],
//         chips:[],
//         price: '2990 рублей',
//     }
// ]
//
// export const LOCATIONS = [
//     {
//         id: 111,
//         title: 'Bim Пятницкая',
//         description: 'Салон по адресу ул. Пятницкая д. 33 ',
//         description_2: 'Часы работы: Пн-Вс 10:00 - 20:00',
//         imageList: [clinic_1],
//         resources: [
//             { from: '10:00', to: '11:00', type: 'massage', status: 'free' },
//             { from: '11:00', to: '12:00', type: 'massage', status: 'free' },
//             { from: '12:00', to: '13:00', type: 'massage', status: 'free' },
//             { from: '13:00', to: '11:00', type: 'massage', status: 'free' },
//             { from: '14:00', to: '12:00', type: 'massage', status: 'free' },
//             { from: '15:00', to: '13:00', type: 'massage', status: 'free' }
//         ],
//         chips: [
//             {
//                 label: "10:00"
//             }
//         ],
//         price: 123,
//     }
// ]
